import { render, staticRenderFns } from "./Categorias.vue?vue&type=template&id=4c37d9b6&scoped=true&"
import script from "./Categorias.vue?vue&type=script&lang=js&"
export * from "./Categorias.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c37d9b6",
  null
  
)

export default component.exports